import { render, staticRenderFns } from "./TelegramTest.vue?vue&type=template&id=0f9b6cb6"
import script from "./TelegramTest.vue?vue&type=script&lang=js"
export * from "./TelegramTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports